const getSkillTooltipContent = (userSkills) => {
 let skillNames = '';
    if (userSkills && userSkills.length > 0) {
      for (let i = 0; i < userSkills.length; i++) {
        if (i !== userSkills.length - 1) {
          skillNames += userSkills[i].skill_content + ', '
        } else {
          skillNames += userSkills[i].skill_content;
        }
      }
    }
    return skillNames;
}

const getPhoneTooltipContent = (user) => {
    let text = user && user.phone_number ? user.phone_number.toString() : '';
    let countryCode = '';
    let areaCode = '';
    let remaining = '';
    let displayText = text;
    if (text.length > 0) {
        if (text.length === 11) {
            countryCode = text.substring(0, 1);
            areaCode = text.substring(1, 4);
            remaining = text.substring(4);
            displayText = `${countryCode} (${areaCode}) ${remaining}`;
        } else if (text.length === 10) {
            displayText = text;
        }
    }
    return displayText;
}

const getEmailTooltipContent = (user) => {
    return (user && user.email ? user.email : '');
}

const getPositionTooltipContent = (user) => {
  return (user && user.position ? (user.position.length < 20 ? '' : user.position ) : '');
}

const getGroupTooltipContent = (userGroups) => {
    let groupNames = '';
    if (userGroups && userGroups.length > 0) {
      for (let i = 0; i < userGroups.length; i++) {
        if (i !== userGroups.length - 1) {
          groupNames += userGroups[i].channel_name + ', '
        } else {
          groupNames += userGroups[i].channel_name;
        }
      }
    }
    return groupNames;
}

const getDepartmentTooltipContent = (userDepartments) => {
    let deptNames = '';
    if (userDepartments && userDepartments.length > 0) {
      for (let i = 0; i < userDepartments.length; i++) {
        if (i !== userDepartments.length - 1) {
          deptNames += userDepartments[i].name + ', '
        } else {
          deptNames += userDepartments[i].name;
        }
      }
    }
    return deptNames;
}

const getRoleTooltipContent = (userRoles) => {
    let roleNames = '';
    if (userRoles && userRoles.length > 0) {
      for (let i = 0; i < userRoles.length; i++) {
        if (i !== userRoles.length - 1) {
          roleNames += userRoles[i].name + ', '
        } else {
          roleNames += userRoles[i].name;
        }
      }
    }
    return roleNames;
}



export default {
    getPhoneTooltipContent,
    getEmailTooltipContent,
    getGroupTooltipContent,
    getDepartmentTooltipContent,
    getSkillTooltipContent,
    getRoleTooltipContent,
    getPositionTooltipContent,
}